import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { translate } from 'react-i18next';
import FlatButton from 'material-ui/FlatButton';
import swal from 'sweetalert';
import { Table } from 'react-bootstrap';
import SvgIcon from 'react-icons-kit';
import {notification} from 'react-icons-kit/icomoon/notification';
import moment from 'moment';

var Config = require('../../../config');

class ModalOrientation extends Component{
	constructor(props, context) {
		super(props, context);
		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.onSave = this.onSave.bind(this);
		this.handleChange = this.handleChange.bind(this);
		
		this.state = {
            show: false,
            pos:"",
		};
	}

	componentDidMount() {
		this.props.onRef(this);
	}

	componentWillUnmount() {
		this.props.onRef(null)
	}

	handleChange(e){
        this.setState({
            [e.target.name]: e.target.value
        });
	}

	handleClose() {
		this.setState({ show: false, pos:""});
	}

	handleShow() {
		this.setState({show: true});
		
	}

	onSave(){
		if(this.state.pos !== ""){
            this.props.onPrint(this.state.pos);
        }else{
            swal('Error', 'Debe seleccionar una posición', 'error');
        }
			
	}

	render(){
		const { t } = this.props;
		return(
			<div>
			<Modal bsSize={"sm"} show={this.state.show} onHide={this.handleClose}>
		       	<Modal.Header closeButton>
		        	<Modal.Title>
                        Seleccione la posición de inicio para la etiqueta
		        	</Modal.Title>
		        </Modal.Header>
		        <Modal.Body >
		        	<div className="row" style={{paddingLeft:"10px",paddingRight:"10px"}}>
                        <div className="col-xs-12">
                            
                            <div className="col-xs-12 col-sm-6">
                                <label>Posición</label>
                                <select className="form-control" id="pos" name="pos" value={this.state.pos} onChange={(e)=>this.handleChange(e)}>
                            
                                    <option value="">Seleccione...</option>
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                    <option value="4">4</option>
                                    <option value="5">5</option>
                                    <option value="6">6</option>
                                </select>
                            </div>
                        </div>
				    </div>
		        </Modal.Body>
		        <Modal.Footer>
		        	<FlatButton primary={true} label={'Continuar'} onClick={this.onSave}  />
		        	<FlatButton primary={true} label={'Cancelar'} onClick={this.handleClose} />
		        </Modal.Footer>
	      	</Modal>
	      	</div>
		);
	}
}

export default translate('translations')(ModalOrientation);